import type { CustomerDetailLabels } from "./types";

export const trCustomerLabels: CustomerDetailLabels = {
  pageTitle: "Müşteri",
  backToList: "Müşterilere dön",
  vipLabel: "VIP",
  loyaltyTier: {
    bronze: "Bronz",
    silver: "Gümüş",
    gold: "Altın",
    platinum: "Platin",
  },
  loyaltyPoints: (p) => `${p.toLocaleString("tr-TR")} puan`,
  preferredChannel: {
    sms: "SMS",
    whatsapp: "WhatsApp",
    email: "E-posta",
    call: "Telefon",
  },
  stats: {
    totalSpend: "Toplam harcama",
    averageTicket: "Ortalama sepet",
    visits: "Ziyaret",
    upcoming: "Yaklaşan",
    completed: "Tamamlanan",
    cancelled: "İptal",
  },
  tabs: {
    overview: "Özet",
    pets: "Evcil Hayvanlar",
    timeline: "Geçmiş",
    notes: "Notlar",
  },
  overview: {
    quickFactsTitle: "Hızlı bilgiler",
    petsTitle: (n) => `Evcil Hayvanlar (${n})`,
    memberSince: (d) => `Üyelik başlangıcı: ${d}`,
    lastVisit: (d) => `Son ziyaret: ${d}`,
    nextAppointment: (d) => `Sonraki randevu: ${d}`,
    noUpcoming: "Yaklaşan randevu yok",
    preferredChannelLabel: "Tercih edilen kanal",
    mostBookedService: "En çok alınan hizmet",
    preferredStaff: "Tercih edilen personel",
    pinnedNote: "Sabitlenmiş not",
    readMore: "Devamını oku",
    noNote: "Henüz not eklenmedi.",
    newAppointment: "Yeni Randevu",
    aiInsightDismiss: "Kapat",
  },
  pet: {
    species: { dog: "Köpek", cat: "Kedi", bird: "Kuş", other: "Diğer" },
    sex: { male: "Erkek", female: "Dişi", unknown: "Bilinmiyor" },
    neutered: "Kısırlaştırılmış",
    notNeutered: "Kısırlaştırılmamış",
    weightKg: (kg) => `${kg.toLocaleString("tr-TR")} kg`,
    age: (y) => (y === 1 ? "1 yaş" : `${y} yaş`),
    microchip: (id) => `Çip: ${id}`,
    vaccinations: "Aşılar",
    vaccinationStatus: { current: "Güncel", due_soon: "Yakında", overdue: "Geçmiş" },
    nextDue: (d) => `Sıradaki: ${d}`,
    allergies: "Alerjiler",
    chronic: "Kronik durumlar",
    behavior: "Davranış notu",
    addPet: "Evcil hayvan ekle",
    editPet: "Düzenle",
    newAppointmentForPet: (n) => `${n} için randevu`,
    noVaccinations: "Aşı kaydı yok",
    emptyTitle: "Henüz evcil hayvan yok",
    emptyBody: "Bu müşteriye ait kayıtlı evcil hayvan bulunmuyor.",
  },
  timeline: {
    title: "Geçmiş aktivite",
    empty: "Henüz aktivite yok",
    types: {
      appointment: "Randevu",
      payment: "Ödeme",
      note: "Not",
      vaccination: "Aşı",
      review: "Değerlendirme",
    },
    today: "Bugün",
    yesterday: "Dün",
    relativeDays: (d) => `${d} gün önce`,
    filters: {
      all: "Tümü",
      appointment: "Randevular",
      payment: "Ödemeler",
      vaccination: "Aşılar",
      note: "Notlar",
    },
  },
  notes: {
    title: "Dahili notlar",
    placeholder: "Bu müşteri hakkında notlar ekleyin…",
    save: "Kaydet",
    cancel: "İptal",
    edit: "Düzenle",
    empty: "Henüz not yok.",
    saving: "Kaydediliyor…",
  },
  contact: { call: "Ara", whatsapp: "WhatsApp", email: "E-posta", sms: "SMS" },
  appointmentStatus: {
    pending: "Beklemede",
    confirmed: "Onaylandı",
    in_progress: "Sürüyor",
    completed: "Tamamlandı",
    cancelled: "İptal",
    no_show: "Gelmedi",
  },
  states: {
    loadingTitle: "Yükleniyor…",
    notFoundTitle: "Müşteri bulunamadı",
    notFoundBody: "Aradığınız müşteri kaydı mevcut değil.",
    errorTitle: "Müşteri yüklenemedi",
    errorRetry: "Tekrar dene",
  },
};

export const enCustomerLabels: CustomerDetailLabels = {
  pageTitle: "Customer",
  backToList: "Back to customers",
  vipLabel: "VIP",
  loyaltyTier: { bronze: "Bronze", silver: "Silver", gold: "Gold", platinum: "Platinum" },
  loyaltyPoints: (p) => `${p.toLocaleString("en-US")} pts`,
  preferredChannel: { sms: "SMS", whatsapp: "WhatsApp", email: "Email", call: "Phone" },
  stats: {
    totalSpend: "Total spend",
    averageTicket: "Avg ticket",
    visits: "Visits",
    upcoming: "Upcoming",
    completed: "Completed",
    cancelled: "Cancelled",
  },
  tabs: { overview: "Overview", pets: "Pets", timeline: "History", notes: "Notes" },
  overview: {
    quickFactsTitle: "Quick facts",
    petsTitle: (n) => `Pets (${n})`,
    memberSince: (d) => `Member since: ${d}`,
    lastVisit: (d) => `Last visit: ${d}`,
    nextAppointment: (d) => `Next appointment: ${d}`,
    noUpcoming: "No upcoming appointments",
    preferredChannelLabel: "Preferred channel",
    mostBookedService: "Most booked service",
    preferredStaff: "Preferred staff",
    pinnedNote: "Pinned note",
    readMore: "Read more",
    noNote: "No notes yet.",
    newAppointment: "New Appointment",
    aiInsightDismiss: "Dismiss",
  },
  pet: {
    species: { dog: "Dog", cat: "Cat", bird: "Bird", other: "Other" },
    sex: { male: "Male", female: "Female", unknown: "Unknown" },
    neutered: "Neutered",
    notNeutered: "Not neutered",
    weightKg: (kg) => `${kg} kg`,
    age: (y) => (y === 1 ? "1 yr" : `${y} yrs`),
    microchip: (id) => `Chip: ${id}`,
    vaccinations: "Vaccinations",
    vaccinationStatus: { current: "Current", due_soon: "Due soon", overdue: "Overdue" },
    nextDue: (d) => `Next due: ${d}`,
    allergies: "Allergies",
    chronic: "Chronic conditions",
    behavior: "Behavior note",
    addPet: "Add pet",
    editPet: "Edit",
    newAppointmentForPet: (n) => `New appointment for ${n}`,
    noVaccinations: "No vaccination records",
    emptyTitle: "No pets yet",
    emptyBody: "This customer has no pets on file.",
  },
  timeline: {
    title: "Activity history",
    empty: "No activity yet",
    types: {
      appointment: "Appointment",
      payment: "Payment",
      note: "Note",
      vaccination: "Vaccination",
      review: "Review",
    },
    today: "Today",
    yesterday: "Yesterday",
    relativeDays: (d) => `${d} days ago`,
    filters: {
      all: "All",
      appointment: "Appointments",
      payment: "Payments",
      vaccination: "Vaccinations",
      note: "Notes",
    },
  },
  notes: {
    title: "Internal notes",
    placeholder: "Add notes about this customer…",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    empty: "No notes yet.",
    saving: "Saving…",
  },
  contact: { call: "Call", whatsapp: "WhatsApp", email: "Email", sms: "SMS" },
  appointmentStatus: {
    pending: "Pending",
    confirmed: "Confirmed",
    in_progress: "In progress",
    completed: "Completed",
    cancelled: "Cancelled",
    no_show: "No-show",
  },
  states: {
    loadingTitle: "Loading…",
    notFoundTitle: "Customer not found",
    notFoundBody: "The customer record you’re looking for doesn’t exist.",
    errorTitle: "Couldn’t load customer",
    errorRetry: "Try again",
  },
};
